// DS: i1.3
import React from 'react';
import IconWrap from '../IconWrap';
const Points = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "matrix(1 0 0 -1 2 22)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.411 3.967a8.889 8.889 0 0 1 6.667-.911 7.785 7.785 0 0 0-10.69 11.322A8.889 8.889 0 0 1 7.412 3.967z"
    }), /*#__PURE__*/ React.createElement("circle", {
        transform: "rotate(-87.58 11.855 11.666)",
        cx: "11.855",
        cy: "11.666",
        r: "7.222"
    }))));
Points.displayName = 'Points';
export default Points;

//# sourceMappingURL=Points.js.map